import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { SessionStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';
import { AppConstants } from '../constant';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {


  constructor(private http: Http, private session: SessionStorageService, private cookieService: CookieService) { }

  getProfile() {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl + 'MyProfile.asp';
      const headers = new Headers();
      headers.append("Authorization", this.session.retrieve("token"));
      const option = new RequestOptions({ headers: headers });
      this.http.get(url, option).subscribe((res: any) => {
        const response = JSON.parse(res._body);
        if (response.status == 'success') {
          resolve(response);
        } else { reject(response); }
      });
    });
  }
  check(formData) {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl + 'editprofile.asp';
      const body = {
        "firstname": formData.fname,
        "lastname": formData.lname,
        "mobile": formData.mobilenumber,
        "Address1": formData.address1,
        "Address2": formData.address2,
        "pincode": formData.pin,
        "city": formData.city,
        "country": formData.country
      }
      const headers = new Headers();
      headers.append("Authorization", this.session.retrieve("token"));
      const option = new RequestOptions({ headers: headers });
      this.http.post(url, body, option).subscribe((res: any) => {
        const response = JSON.parse(res._body);
        if (response.status == 'Success') {
          resolve(response);
        } else { reject(response); }
      });
    });
  }

  changepas(oldpassword, password) {
    return new Promise((resolve, reject) => {
      const url = AppConstants.baseUrl + 'ChangePassword.asp';
      const body = {
        "oldpassword": oldpassword,
        'newpassword': password
      };
      const headers = new Headers();
      headers.append("Authorization", this.session.retrieve("token"));
      const option = new RequestOptions({ headers: headers });
      this.http.post(url, body, option).subscribe((res: any) => {
        const response = JSON.parse(res._body);
        if (response.status == 'success') {
          resolve(response);
        } else { reject(response); }
      });
    });
  }
}
